<!-- <div [@expandCollapse]="{
    value: isExpanded ? 'expanded' : 'collapsed',
    params: { limitHeight: limitHeight }
  }" class="text-container">
  <p>{{ text }}</p>
</div>

<a (click)="toggleDic()" class="toggle-link">
  {{ isExpanded ? 'Read Less' : 'Read More' }}
</a> -->

<span [innerHtml]="content"></span>
<a style="cursor: pointer;" *ngIf="!isContentToggled" (click)="toggleContent()" i18n><strong>Read
    More</strong></a>
<a style="cursor: pointer;" *ngIf="isContentToggled" (click)="toggleContent()" i18n><strong>Read
    Less</strong></a>
<br>
<br>